import { render, staticRenderFns } from "./cModalViewVoice.vue?vue&type=template&id=b517d534"
import script from "./cModalViewVoice.vue?vue&type=script&lang=js"
export * from "./cModalViewVoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports